import { number, addMethod } from 'yup';

export default () => {
  // eslint-disable-next-line func-names
  addMethod(number, 'minNumber', function (min) {
    return this.test({
      name: 'minNumber',
      message: JSON.stringify({
        message: '${path} must be at least ${min}', // eslint-disable-line no-template-curly-in-string
        values: { min },
      }),
      params: { min },
      test: (value = '') => number().min(min).isValid(value),
    });
  });
};
